import { render } from "./SubscriptionOverviewCard.vue?vue&type=template&id=275d1852"
import script from "./SubscriptionOverviewCard.vue?vue&type=script&lang=js"
export * from "./SubscriptionOverviewCard.vue?vue&type=script&lang=js"

import "./SubscriptionOverviewCard.vue?vue&type=style&index=0&id=275d1852&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__